import { BookingStatus, TravelTypes } from '../constants';
import getTourBookingStatus from './getTourBookingStatus';

// Every other provider leaves bookingStatus empty when nothing was booked, while a failed tour
// still carries the operator's own wording, so only its normalised code tells the outcome
const checkIsTourBookingFailed = (bookingResponse) => {
  if (!bookingResponse || bookingResponse.mode !== TravelTypes.tour) {
    return false;
  }

  const isFailed = getTourBookingStatus(bookingResponse) === BookingStatus.failed;
  return isFailed;
};

export default checkIsTourBookingFailed;
